<template>
  <div>
    <loader v-bind:theme="'light'" v-if="!load_container"></loader> 
    <router-view v-if="load_container"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      load_container: false,
    }
  },
  /*watch: {
    app_lang: function(new_val, old_val) {
      
    }
  },*/
  methods: {
    
  },
  mounted: function() {
    var that = this;
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      that.load_container = true;
    });
  },
  created: function() {
    // this.change_lang('pt');
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
<style type="text/css">
  .cursor-pointer {
    cursor: pointer; 
  }
  .capitalize {
    text-transform: capitalize;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .sidebar .nav-link {
    padding: 15px 10px; 
    font-size: 13px;
  }
  .sidebar .nav-dropdown-items .nav-link {
    padding-left:20px;
    font-size: 13px;
  }
  .sidebar .nav-link .nav-icon {
    margin: 0 4px 0 0;
  }
  .font-11 {
    font-size: 11px;
  }


  .gmap {
      width: 100%;
      height: 100%;
  }
  .gmap.gmap-modal, .my-map-leaflet.map-modal {
    width: 100%;
    height: 260px;
  }
  .card-loader-container {
      height: 500px;
      overflow: auto;
      text-transform: none;
      width: 100%;
      position: relative;
  }
  .card-loader-container.small-height {
      height: 420px;
  }
  .loader-wrapper {
    height: 500px;
    width: 100%;
    position: relative;
  }
  .table-chart-wrapper {
    padding-top: 20px;
  }
  .censos_chart {
    padding-top: 20px;
  }
  .censos_table {
    padding-top: 40px;
  }
  .disclaimer-container {
    top: 0;
    position: absolute;
  }
  .icon-disclaimer {
    cursor: pointer;
    display: none;
  }
  .md-table {
    display: block;
  }
  @media only screen and (max-width: 992px) {
    .disclaimer-container > p {
      display: none;
    }
    .icon-disclaimer {
      display: block;
    }
    .main .container-fluid {
      padding: 0 15px;
    }
    .mobile-list .list-group-item {
      padding: 10px 8px;
    }
  /*  .hidden-desk { /* equivalent: d-lg-none d-block
      display: block;
    }
    .hidden-mob {   /*  equivalent: d-lg-block d-none
      display: none;
    }*/
    .padding-desk-r-15 {
      padding-right: 0;
    }
    .padding-desk-l-15 {
      padding-left: 0;
    }
    .padding-mob-15 {
      padding: 0 15px;
    }
  }

  @media only screen and (max-width : 580px) {
      .disclaimer-container {
        position: static;
      }
      .disclaimer-charts {
        display: none;
      }
      .card-loader-container, .loader-wrapper, .gmap {
        height: 380px;
      }
      .card-loader-container.has_data, .card-loader-container.has_data .loader-wrapper {
        height: auto;
        max-height: 1000px;
        min-height: 380px;
      }
      .tab-content .tab-pane {
        padding: 15px 0;
      }
      .tab-content {
        /*margin-top: 5px;*/
      }
      .nav-pills .nav-link {
        font-size: 13px;
      }
  }
</style>
